import { render } from "./pasosComponent.vue?vue&type=template&id=706a5c06"
import script from "./pasosComponent.vue?vue&type=script&lang=js"
export * from "./pasosComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__